<template>
    <div class="flex-fill d-flex flex-column gap-3">
        <InputSelect
            :datasource="internalDatasource"
            v-model="value"
            :disabled="!editable"
        />
        <AlertMessage
            v-if="!editable"
            type="info"
            size="sm"
            ><span v-html="$tm('organizerselect.locked', '', true)"></span
        ></AlertMessage>
    </div>
</template>
<script lang="ts" setup>
import type { IEditorComponent, ValidatorDef } from '@/objects/gui';
import { AlertMessage, InputSelect } from '@/components';
import { watch, ref } from 'vue';
import { useCommonStore } from '@/stores';
import { useValidator } from '@/composeables';

defineOptions({ inheritAttrs: false });

const props = withDefaults(
    defineProps<{
        validator?: ValidatorDef | null;

        editable?: boolean;
    }>(),
    {
        validator: null,
        editable: true,
    },
);

/**
 * We define the model to make sure the value is bound to the input
 */
const value = defineModel<number>({ required: true });

/**
 * The internal datasource
 */
const data = useCommonStore().OrganizersAsSelectLine;
const internalDatasource = ref({ source: Array.from(data.values()) });

watch(
    () => internalDatasource.value,
    (nv) => {
        // If we cant edit, and we cant load the current value, add it as unchanged
        if (!props.editable && !nv.source.find((o) => o.value == value.value)) {
            nv.source.push({
                text: 'general.unchanged',
                value: value.value,
            });
        }

        let selected = nv.source.find((o) => o.value == value.value);

        if (!selected && nv != undefined && nv.source != undefined && nv.source?.length > 0) {
            value.value = nv.source[0].value as number;
        }
    },
    { immediate: true },
);

defineExpose<IEditorComponent>({
    focus: () => null,
    validateMessage: useValidator(props.validator, value)!.ValidateMessage,
});
</script>
